import styled, { StyledComponentPropsWithRef } from 'styled-components'
import { AppRoute, preventDefaultLinkClickBehavior, useRoute } from 'router'
import { theme } from 'styles/theme'

interface WithOrientation {
  orientation: 'horizontal' | 'vertical'
}

export const TabLink = styled.a<WithIsSelected>`
    font-weight: ${({isSelected}) => isSelected ? 900 : 400};
    transition: none;
    padding-bottom: 10px;
`

export const TabLinkContainer = styled.div<WithOrientation>`
  display: flex;
  flex-direction: ${({orientation}) => orientation === 'horizontal' ? 'row' : 'column'};
  gap: 2em;
  border-${({orientation}) => orientation === 'horizontal' ? 'bottom' : 'right'}: ${theme.borders.tabLinkContainer};

  ${TabLink}.selected {
    border-${({orientation}) => orientation === 'horizontal' ? 'bottom' : 'right'}: solid ${theme.borderWidths.medium} ${theme.colors.MainYellow};
    margin-${({orientation}) => orientation === 'horizontal' ? 'bottom' : 'right'}: -${theme.borderWidths.medium};
  }
`



type TabLinkWithRouteProps = Partial<AppRoute> & StyledComponentPropsWithRef<typeof TabLink>
export const TabLinkWithRoute = ({ name, push, onClick = push, href, ...props }: TabLinkWithRouteProps) => {
  const currentRoute = useRoute()
  const isSelected = currentRoute.name === name || (href !== undefined && currentRoute.href.startsWith(href))
  return (
      <TabLink 
        {...{
          ...(isSelected && { className: 'selected'}),
          isSelected,
          href,
          onClick(e) {
            onClick?.(e)
            if (preventDefaultLinkClickBehavior(e) && push) {
              push()
            }
          },
          ...props,
        }}
      />
    )
}